export default {
  page: {
    marginTop: 24,
    justifyContent: 'center',
    paddingBottom: 64,
    alignContent: 'flex-start',
  },
};
